import {
  GALLERY_PAYWALL_DIALOG_OPEN_EVENT,
  PAYWALLCONTROL_OPENED_EVENT,
} from "./events.js";

export class PaywallControl extends HTMLElement {
  connectedCallback() {
    const restrictedElements = this.querySelectorAll(".ws-open-dialog"),
      dialog = document.querySelector(
        "#paywall-dialog",
      ) as HTMLDialogElement | null;

    if (restrictedElements.length && dialog) {
      restrictedElements.forEach((element) => {
        element.addEventListener("click", function (event) {
          event.preventDefault();
          dialog.showModal();
          document.dispatchEvent(new CustomEvent(PAYWALLCONTROL_OPENED_EVENT));
        });
      });
    }

    document.addEventListener(
      GALLERY_PAYWALL_DIALOG_OPEN_EVENT,
      this.handleOpenModal,
    );
  }

  handleOpenModal = () => {
    const dialog = document.querySelector(
      "#paywall-dialog",
    ) as HTMLDialogElement | null;
    if (dialog) {
      dialog.showModal();
      document.dispatchEvent(new CustomEvent(PAYWALLCONTROL_OPENED_EVENT));
    }
  };

  disconnectedCallback() {
    document.removeEventListener(
      GALLERY_PAYWALL_DIALOG_OPEN_EVENT,
      this.handleOpenModal,
    );
  }
}

"customElements" in window &&
  customElements.get("ws-paywallcontrol") === undefined &&
  customElements.define("ws-paywallcontrol", PaywallControl);

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface HTMLElementTagNameMap {
    "ws-paywallcontrol": PaywallControl;
  }
}
